/** 플랫폼 관리자(이용자 통계·전체 계정 RPC 등). DB `admin_platform_*`와 동일 이메일이어야 합니다. */
export const PLATFORM_ADMIN_EMAIL = 'jeongwonsang@gmail.com';

export function isPlatformAdminEmail(email: string): boolean {
  return email.trim().toLowerCase() === PLATFORM_ADMIN_EMAIL.trim().toLowerCase();
}
